import lodashUtil from "lodash";
import { getDayForHourAndMin } from '../school/weeklyCalendar/WeeklyCalendarUtil';

export const constructWeeklyAvailabilityDisplayList = weeklyAvailabilitySchedule => {
  let weekDaysJSON = {
    "1": "SUN",
    "2": "MON",
    "3": "TUE",
    "4": "WED",
    "5": "THU",
    "6": "FRI",
    "7": "SAT"
  }
  let weeklyAvailabilityDisplayList = []
  if (weeklyAvailabilitySchedule.length > 0) {
    for (let i = 0; i < weeklyAvailabilitySchedule.length; i++) {
      let weeklyAvailabilityDisplayString = "";
      if (weeklyAvailabilitySchedule[i].weekDays.length === 1) {
        weeklyAvailabilityDisplayString = weekDaysJSON[weeklyAvailabilitySchedule[i].weekDays[0]] + " : " + weeklyAvailabilitySchedule[i].outFrom.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) + "-" + weeklyAvailabilitySchedule[i].outUntill.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
      } else {
        weeklyAvailabilityDisplayString = weekDaysJSON[weeklyAvailabilitySchedule[i].weekDays[0]] + " - " + weekDaysJSON[weeklyAvailabilitySchedule[i].weekDays[weeklyAvailabilitySchedule[i].weekDays.length - 1]] + " : " + weeklyAvailabilitySchedule[i].outFrom.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
          + " - " + weeklyAvailabilitySchedule[i].outUntill.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) + "\n";
      }
      weeklyAvailabilityDisplayList.push(weeklyAvailabilityDisplayString)
    }
  }
  return weeklyAvailabilityDisplayList
};


export const constructWeeklyAvailability = weeklyAvailabilitySchedule => {
  let weekDaysJSON = {
    "1": "Sun",
    "2": "Mon",
    "3": "Tue",
    "4": "Wed",
    "5": "Thu",
    "6": "Fri",
    "7": "Sat"
  }
  let weeklyAvailabilityDisplay = {}
  let weeklyAvailabilityList = [];
  let weeklyAvailabilityDisplayList = []
  if (weeklyAvailabilitySchedule.length > 0) {
    for (let i = 0; i < weeklyAvailabilitySchedule.length; i++) {
      let daysArray = [];
      if (weeklyAvailabilitySchedule[i].weekDays.length > 0) {
        daysArray = JSON.parse(JSON.stringify(weeklyAvailabilitySchedule[i].weekDays));
        daysArray = daysArray.sort()

        let daySequenceValidation = true;
        if (daysArray.length <= 2) {
          for (let x = 0; x < daysArray.length; x++) {
            daysArray[x] = weekDaysJSON[Number(daysArray[x])]
            daysArray.toString();
          }
        } else {
          for (let y = 0; y < daysArray.length - 1; y++) {
            let dayNumber = Number(daysArray[y]);
            let nextDayNumber = Number(daysArray[y + 1]);
            if (dayNumber + 1 != nextDayNumber) {
              daySequenceValidation = false;
              break;
            }
          }
          if (daySequenceValidation === false) {
            for (let g = 0; g < daysArray.length; g++) {
              daysArray[g] = weekDaysJSON[Number(daysArray[g])]
            }
            daysArray.toString();
          } else {
            daysArray = `${weekDaysJSON[Number(daysArray[0])]}-${weekDaysJSON[Number(daysArray[daysArray.length - 1])]}`
          }
        }

      }

      for (let j = 0; j < weeklyAvailabilitySchedule[i].weekDays.length; j++) {
        let weeklyAvailability = {};
        weeklyAvailability.groupNumber = i;
        weeklyAvailability.weekDay = weeklyAvailabilitySchedule[i].weekDays[j];
        if (typeof (weeklyAvailabilitySchedule[i].outFrom) != 'object') {
          weeklyAvailability.outFrom = weeklyAvailabilitySchedule[i].outFrom
          weeklyAvailability.outFrom = weeklyAvailabilitySchedule[i].outFrom
        } else {
          weeklyAvailability.outFrom = weeklyAvailabilitySchedule[i].outFrom.getTime();
        }
        if (typeof (weeklyAvailabilitySchedule[i].outUntill) != 'object') {
          weeklyAvailability.outUntill = weeklyAvailabilitySchedule[i].outUntill

        }
        else {
          weeklyAvailability.outUntill = weeklyAvailabilitySchedule[i].outUntill.getTime();

        }
        weeklyAvailability.outFromStr = weeklyAvailabilitySchedule[i].outFromStr
        weeklyAvailability.outUntillStr = weeklyAvailabilitySchedule[i].outUntillStr
        weeklyAvailabilityList.push(weeklyAvailability);
      }
      let weeklyAvailabilityDisplayString = "";

      if (typeof (weeklyAvailabilitySchedule[i].outFrom) != 'object' || typeof (weeklyAvailabilitySchedule[i].outUntill) != "object") {
        weeklyAvailabilitySchedule[i].outFrom = new Date(weeklyAvailabilitySchedule[i].outFrom)
        weeklyAvailabilitySchedule[i].outUntill = new Date(weeklyAvailabilitySchedule[i].outUntill)
      }

      weeklyAvailabilityDisplayString =
        daysArray
        + " : "
        + weeklyAvailabilitySchedule[i].outFrom.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        + " - "
        + weeklyAvailabilitySchedule[i].outUntill.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
      weeklyAvailabilityDisplayList.push(weeklyAvailabilityDisplayString)
    }
  }
  weeklyAvailabilityDisplay.weeklyAvailabilityList = weeklyAvailabilityList
  weeklyAvailabilityDisplay.weeklyAvailabilityDisplayList = weeklyAvailabilityDisplayList
  return weeklyAvailabilityDisplay;
};


export const destructorOfWeeklyAvailabilitySchedule = (WeeklyAvailability) => {
  if (
    WeeklyAvailability !== undefined &&
    !lodashUtil.isEmpty(WeeklyAvailability) && WeeklyAvailability.availableForAllHours === (false || "false")
  ) {
    let weeklyAvailabilitySchedule = [];
    let weeklyAvailability = WeeklyAvailability;
    if (weeklyAvailability.availableForAllHours == true) {
      weeklyAvailability.availableForAllHours = "true"
    } else {
      weeklyAvailability.availableForAllHours = "false"
      const results = lodashUtil.groupBy(
        weeklyAvailability.unAvailableDuration,
        "groupNumber"
      );
      const groupNumbers = lodashUtil.keys(results);

      for (let i = 0; i < groupNumbers.length; i++) {
        let schedule = {};
        schedule.weekDays = [];
        for (let j = 0; j < results[groupNumbers[i]].length; j++) {
          schedule.weekDays.push(
            results[groupNumbers[i]][j].weekDay.toString()
          );
          schedule.id = i;
          schedule.outFrom = results[groupNumbers[i]][j].outFrom
          schedule.outFrom = new Date(schedule.outFrom);
          schedule.outUntill = results[groupNumbers[i]][j].outUntill;
          schedule.outUntill = new Date(schedule.outUntill)
          schedule.outFromStr = results[groupNumbers[i]][j].outFromStr
          schedule.outUntillStr = results[groupNumbers[i]][j].outUntillStr
        }
        weeklyAvailabilitySchedule.push(schedule);
      }
    }
    if (weeklyAvailabilitySchedule.length < 0) {
      weeklyAvailabilitySchedule = [
        { id: 1, weekDays: [], outFrom: "", outUntill: "", outFromStr: "", outUntillStr: "" }
      ]
    }
    return weeklyAvailabilitySchedule;
  }
}

export const initWeeklyAvailability = () => {
  let outFromStr = "08:30";
  let outUntillStr = "09:30";

  // let outFrom = getDayForHourAndMin(outFromStr);
  // let outUntill = getDayForHourAndMin(outUntillStr);
  let outFrom = new Date(1970, 0, 1, 8, 30, 0, 0);
  let outUntill = new Date(1970, 0, 1, 9, 30, 0, 0);

  return { outFrom: outFrom, outUntill: outUntill, outFromStr: outFromStr, outUntillStr: outUntillStr };
}
